import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import { setButtonLoading } from "../lib/button_loading"

// Trust Center — Compliance Website (Step 3, epic #6718 slice ⑤ — #6960).
//
// Auto-provisions the agent's public compliance site. The agent enters no data:
// "Create My Compliance Website" POSTs to the provision endpoint, which mints a
// public_slug (idempotent) and returns the live URLs. On success we fill the
// pre-rendered links, reveal the "Website Created" block, and hide the CTA.
//
// Provisioning also happens server-side on the wizard's Continue (idempotent),
// so this controller is a UX affordance, not the only path to a live site.
export default class extends Controller {
  static targets = [
    "result", "cta", "createBtn", "message",
    "siteLink", "optInLink", "privacyLink", "termsLink", "smsTermsLink",
  ]

  static values = { provisionUrl: String }

  async create() {
    if (this.busy) return
    this.setBusy(true)
    this.clearMessage()

    try {
      const response = await post(this.provisionUrlValue, { responseKind: "json" })
      const data = await response.json
      if (response.ok && data.ok) {
        this.applyLinks(data)
        this.reveal()
      } else {
        this.showMessage(data.message || "Something went wrong. Please try again.")
      }
    } catch {
      this.showMessage("Something went wrong. Please try again.")
    } finally {
      this.setBusy(false)
    }
  }

  applyLinks(data) {
    if (this.hasSiteLinkTarget && data.url) {
      this.siteLinkTarget.href = data.url
      this.siteLinkTarget.textContent = data.url
    }
    if (this.hasOptInLinkTarget && data.opt_in_url) this.optInLinkTarget.href = data.opt_in_url
    if (this.hasPrivacyLinkTarget && data.privacy_url) this.privacyLinkTarget.href = data.privacy_url
    if (this.hasTermsLinkTarget && data.terms_url) this.termsLinkTarget.href = data.terms_url
    if (this.hasSmsTermsLinkTarget && data.sms_terms_url) this.smsTermsLinkTarget.href = data.sms_terms_url
  }

  reveal() {
    if (this.hasResultTarget) this.resultTarget.classList.remove("d-none")
    if (this.hasCtaTarget) this.ctaTarget.classList.add("d-none")
  }

  setBusy(busy) {
    this.busy = busy
    // BUTTON-8: shared spinner + aria-busy, label kept.
    if (this.hasCreateBtnTarget) setButtonLoading(this.createBtnTarget, busy)
  }

  clearMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = ""
      this.messageTarget.classList.remove("gl-text-danger")
    }
  }

  showMessage(message) {
    if (!this.hasMessageTarget) return
    this.messageTarget.textContent = message
    this.messageTarget.classList.add("gl-text-danger")
  }
}
